<div class="auth">
  <div class="auth__glow" aria-hidden="true"></div>

  <header class="auth__top">
    <a routerLink="/" class="auth-brand" aria-label="PulseWatch home">
      <span class="auth-brand__mark" aria-hidden="true">
        <svg viewBox="0 0 64 64"><path d="M9 35h11l5-12 8 24 6-17 3 5h13" /></svg>
      </span>
      <span class="auth-brand__name">PulseWatch</span>
    </a>
    <a routerLink="/knowledge-base" class="auth__help">Help</a>
  </header>

  <main class="auth__main auth__main--single">
    <section class="auth-card">
      @if (loading()) {
        <p class="auth-card__sub">Checking your invitation…</p>
      } @else if (invalidLink()) {
        <div class="auth-success" data-testid="invite-invalid">
          <div class="auth-success__icon auth-success__icon--error"><i class="bx bx-link-alt"></i></div>
          <h1>This link doesn’t work anymore</h1>
          <p>Invitation links work once and expire after 7 days. Ask the person who invited you to send a new one.</p>
        </div>
        <p class="auth-card__alt">Already a member? <a routerLink="/login" class="auth-link">Log in</a></p>
      } @else if (invitation(); as invite) {
        <h1 data-testid="invite-title">Join {{ invite.organization }}</h1>
        <p class="auth-card__sub">
          {{ invite.invited_by || 'A colleague' }} invited you to PulseWatch to see {{ invite.organization }}’s uptime, errors and traces.
        </p>
        <p class="invite-email">You’ll sign in as <strong data-testid="invite-email">{{ invite.email }}</strong></p>

        <form [formGroup]="form" (ngSubmit)="accept()" novalidate>
          <div class="auth-row">
            <label class="auth-field">
              <span>First name</span>
              <div class="auth-field__box" [class.is-invalid]="invalid('first_name')">
                <input type="text" formControlName="first_name" placeholder="Hans" autocomplete="given-name" data-testid="invite-first-name" />
              </div>
              @if (has('first_name', 'required')) {
                <small class="auth-field__error">Required.</small>
              }
            </label>
            <label class="auth-field">
              <span>Last name</span>
              <div class="auth-field__box" [class.is-invalid]="invalid('last_name')">
                <input type="text" formControlName="last_name" placeholder="Müller" autocomplete="family-name" data-testid="invite-last-name" />
              </div>
              @if (has('last_name', 'required')) {
                <small class="auth-field__error">Required.</small>
              }
            </label>
          </div>

          <label class="auth-field">
            <span>Choose a password</span>
            <div class="auth-field__box" [class.is-invalid]="invalid('password')">
              <i class="bx bx-lock-alt" aria-hidden="true"></i>
              <input [type]="showPassword() ? 'text' : 'password'" formControlName="password"
                placeholder="At least 8 characters" autocomplete="new-password" data-testid="invite-password" />
              <button type="button" class="auth-field__toggle" (click)="showPassword.set(!showPassword())"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'">
                <i class="bx" [class.bx-show]="!showPassword()" [class.bx-hide]="showPassword()"></i>
              </button>
            </div>
            @if (has('password', 'required')) {
              <small class="auth-field__error">Password is required.</small>
            } @else if (has('password', 'minlength')) {
              <small class="auth-field__error">Password must be at least 8 characters.</small>
            }
            @if (serverError('password'); as message) {
              <small class="auth-field__error">{{ message }}</small>
            }
          </label>

          @if (formError()) {
            <div class="auth-alert" role="alert" data-testid="invite-error"><i class="bx bx-error-circle"></i>{{ formError() }}</div>
          }

          <button type="submit" class="auth-btn" [disabled]="submitting()" data-testid="invite-accept">
            @if (submitting()) {
              <span class="auth-btn__spinner" aria-hidden="true"></span> Joining…
            } @else {
              Join {{ invite.organization }} <i class="bx bx-right-arrow-alt"></i>
            }
          </button>
        </form>
      }
    </section>
  </main>

  <footer class="auth__footer">{{ versions.hash }} · {{ versions.date | date: 'short' }}</footer>
</div>
